import { styled } from "@mui/material/styles";

import { IMAGES } from "@/assets/images";

export const LayoutStyled = styled("div")(({ theme }) => ({
  "& .banner": {
    background: `url(${IMAGES.banner.src})`,
    backgroundColor: "#F8FBFF",
    backgroundPosition: "top center",
    backgroundRepeat: "repeat-y",
    backgroundSize: "100% auto",
    padding: "16px 0 27px",
    height: "auto",
    minHeight: "100dvh",
  },
  "& .memberList": {
    background: "#ffffff",
    border: "1px solid rgba(191, 227, 255, 0.72)",
    borderRadius: "16px",
    boxSizing: "border-box",
    height: "auto",
    paddingBottom: "30px",
    margin: "0 auto 17px !important",
    position: "static",
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    "& .memberList": {
      height: "auto",
      minHeight: "444px",
      maxWidth: "350px",
      position: "sticky",
      top: "16px",
      width: "100%",
    },
  },
  [theme.breakpoints.down("md")]: {
    "& .memberList": {
      position: "static !important",
      width: "100% !important",
    },
  },
  "& .roster": {
    width: "100% !important",
  },
}));
